import React from 'react'
import img from "../../assets/images/homeimg2.svg"
import { motion } from 'motion/react';
import { Link } from 'react-router-dom';

const AboutUs = () => {
  return (
    <div className="bg-gradient-to-b from-[#E6DFFF] via-white to-white z-30 relative">
      <div className="max-w-screen-2xl mx-auto px-5 lg:px-20 py-8 lg:py-28">
        <div className="flex flex-col sm:flex-row gap-10 sm:gap-0">
          <div className="sm:w-[40%] overflow-hidden rounded-[50px]">
            <img
              src={img}
              alt=""
              className="w-full hover:scale-125 transition-all duration-1000"
            />
          </div>
          <div className="sm:w-[60%] sm:pl-20">
            <div className="relative mb-9">
              <motion.h3
                initial={{ x: -50, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
                className="poppins-regular text-primary z-20 relative"
              >
                ABOUT ME
              </motion.h3>
              <div className="size-16 bg-[#E7E9FF] rounded-full absolute -top-5 -left-5"></div>
            </div>
            <div className="mb-10">
              <motion.h2
                initial={{ x: 100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
                className="text-4xl sm:text-5xl montserrat-regular mb-7"
              >
                A{" "}
                <span className="montserrat-semibold text-secondary">
                  Financial Visionary
                </span>{" "}
                <br />
                with 30+ Years Shaping
                <span className="montserrat-semibold text-secondary">
                  {" "}
                  the Medical Industry
                </span>
              </motion.h2>
              <motion.p
                initial={{ x: 100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
                className="montserrat-regular mb-8"
              >
                Leveraging three decades of
                expertise in the medical industry within numerous organizations.
              </motion.p>
              <div className="">
                <motion.h4
                  initial={{ x: 100, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.3, delay: 1 }}
                  viewport={{ once: true }}
                  className="text-secondary poppins-medium "
                >
                  Key Attributes:
                </motion.h4>
                <ul className="text-secondary list-disc montserrat-regular ml-4 mb-4">
                  <motion.li
                    initial={{ x: 100, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.3, delay: 1.3 }}
                    viewport={{ once: true }}
                    className=""
                  >
                    Driving growth through strategic financial planning and
                    analysis
                  </motion.li>
                  <motion.li
                    initial={{ x: 100, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.3, delay: 1.6 }}
                    viewport={{ once: true }}
                    className=""
                  >
                    Leading successful mergers and acquisitions
                  </motion.li>
                  <motion.li
                    initial={{ x: 100, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.3, delay: 1.9 }}
                    viewport={{ once: true }}
                    className=""
                  >
                    Ensuring compliance with healthcare regulations
                  </motion.li>
                </ul>
                <motion.h4
                  initial={{ x: 100, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.3, delay: 1 }}
                  viewport={{ once: true }}
                  className="text-secondary"
                >
                  I focus on optimizing operations, fostering growth, and
                  achieving long-term success.
                </motion.h4>
              </div>
            </div>
            <Link to="/about-us" onClick={() => window.scrollTo(0, 0)}>
              <button className="bg-secondary py-3 px-7 montserrat-medium rounded-full text-white hover:bg-primary  transition-all duration-300">
                About Me
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs


